<template>
  <div>
    <v-row>
      <v-col
        cols="12"
        md="12"
      >
        <base-card>
          <v-card-title class="pb-0">
            <div class="card-title mb-0">
              {{ job.name }}
            </div>
          </v-card-title>

          <v-card-text>
            <div
              class="d-flex justify-space-between flex-wrap pt-2"
            >
              <div>
                <p
                  class="text--disabled font-weight-medium text-18 mb-2"
                >
                  Job Details:
                </p>

                <div class="d-flex align-center mb-1">
                  <h6 class="ma-0 mr-2">
                    Template:
                  </h6>

                  <span>
                    <a :href="'/dashboard/' + job.project_id">
                      {{ template.name }}
                    </a>
                  </span>
                </div>

                <div class="d-flex align-center mb-1">
                  <h6 class="ma-0 mr-2">
                    Job ID:
                  </h6>

                  <span>
                    {{ job.nexrender_job_id }}
                  </span>
                </div>

                <div class="d-flex align-center mb-1">
                  <h6 class="ma-0 mr-2">
                    Status:
                  </h6>

                  <span
                    v-if="job.job_status.state === 'render:dorender'"
                    class="text-primary"
                  >
                    Render {{ job.job_status.renderProgress }}%
                  </span>

                  <span
                    v-else-if="job.job_status.state === 'finished'"
                    class="text-success"
                  >
                    Done
                  </span>

                  <span
                    v-else-if="job.job_status.state === 'error'"
                    class="text-danger"
                  >
                    Error
                  </span>

                  <span v-else>
                    {{ job.job_status.state }}
                  </span>
                </div>

                <div
                  v-if="job.job_status.state === 'error'"
                  class="d-flex align-center mb-1"
                >
                  <h6 class="ma-0 mr-2">
                    Error:
                  </h6>

                  <div
                    class="text-danger"
                    style="max-width: 800px;"
                  >
                    {{ job.job_status.error }}
                  </div>
                </div>

                <div class="d-flex align-center mb-1">
                  <h6 class="ma-0 mr-2">
                    Master:
                  </h6>

                  <span>
                    {{ job.job_status.jobCreator }}
                  </span>
                </div>

                <div
                  v-if="job.job_status.jobExecutor"
                  class="d-flex align-center mb-1"
                >
                  <h6 class="ma-0 mr-2">
                    Executor:
                  </h6>

                  <span>
                    {{ job.job_status.jobExecutor }}
                  </span>
                </div>

                <div
                  v-if="job.job_status.state === 'finished' && isSuper"
                  class="d-flex align-center mb-1"
                >
                  <h6 class="ma-0 mr-2">
                    Result URL FTP:
                  </h6>

                  <span style="word-break: break-all;">
                    {{ maskFTPPassword(job.output_url) }}
                  </span>
                </div>

                <div
                  v-if="job.job_status.state === 'finished' && job.result_url"
                  class="d-flex align-center mb-1 text-wrap"
                >
                  <h6 class="ma-0 mr-2">
                    Result URL HTTP:
                  </h6>

                  <span>
                    <a
                      :href="job.result_url"
                      target="_blank"
                      style="word-break: break-all;"
                    >
                      {{ job.result_url }}
                    </a>
                  </span>
                </div>
              </div>

              <div class="md:text-right sm:text-left">
                <p
                  class="text--disabled font-weight-medium text-18 ma-0"
                >
                  Duration Time:
                </p>

                <h4
                  class="ma-0 primary--text font-weight-medium"
                >
                  <v-icon
                    color="primary"
                    size="18"
                  >
                    mdi-timer
                  </v-icon>

                  {{ job.jobTimeCalc }}
                </h4>

                <p class="ma-0 text--disabled text-body-2">
                  Started:
                  {{ moment.utc(job.create_time).format('D MMM HH:mm:ss') }}
                </p>
              </div>
            </div>
          </v-card-text>
        </base-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col
        cols="12"
        :md="isSuper ? 4 : 12"
      >
        <base-card v-if="imageAssets.length">
          <v-card-title class="d-flex justify-space-between">
            <p class="text-body-2">
              Image Assets ({{ imageAssets.length }})
            </p>

            <div v-if="imageAssets.length > 1">
              <v-icon
                color="primary"
                @click="sliderImage--"
              >
                mdi-chevron-left
              </v-icon>

              <v-icon
                color="primary"
                @click="sliderImage++"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card-title>

          <v-card-text>
            <v-carousel
              v-model="sliderImage"
              hide-delimiters
              :show-arrows="false"
              height="auto"
              cycle
              light
            >
              <v-carousel-item
                v-for="(slide, i) in imageAssets"
                :key="i"
              >
                <div>
                  <div
                    class="card-title"
                    style="min-height: 173px;"
                  >
                    <a
                      :href="slide.image"
                      target="_blank"
                    >
                      <v-img
                        class="h-10 object-cover"
                        style="
                          background-color: #eee;
                          max-width: 307px;
                          max-height: 173px;
                        "
                        :src="slide.image"
                      />
                    </a>
                  </div>

                  <div class="d-flex justify-space-between py-4 pt-0">
                    <div>
                      <v-icon
                        class="mr-1"
                        color="primary"
                      >
                        mdi-layers
                      </v-icon>

                      <span class="text--primary">
                        {{ slide.composition.name }} - {{ slide.layer }}
                      </span>
                    </div>

                    <span v-if="slide.composition.footage_width">
                      {{ slide.composition.footage_width }}x{{ slide.composition.footage_height }},
                      {{ slide.composition.footage_seconds.toFixed(2) }} s
                    </span>
                  </div>
                </div>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
        </base-card>

        <base-card class="mt-4">
          <v-card-title class="d-flex justify-space-between">
            <p class="text-body-2">
              Text Assets ({{ textAssets.length }})
            </p>

            <div v-if="textAssets.length > 1">
              <v-icon
                color="primary"
                @click="sliderText--"
              >
                mdi-chevron-left
              </v-icon>

              <v-icon
                color="primary"
                @click="sliderText++"
              >
                mdi-chevron-right
              </v-icon>
            </div>
          </v-card-title>

          <v-card-text>
            <v-carousel
              v-model="sliderText"
              hide-delimiters
              :show-arrows="false"
              height="auto"
              cycle
              light
            >
              <v-carousel-item
                v-for="(slide, i) in textAssets"
                :key="i"
              >
                <div>
                  <div class="card-title">
                    {{ slide.text }}
                  </div>

                  <div class="d-flex justify-space-between py-4 pt-0">
                    <div>
                      <v-icon
                        class="mr-1"
                        color="primary"
                      >
                        mdi-layers
                      </v-icon>

                      <span class="text--primary">
                        {{ slide.composition.name }} - {{ slide.layer }}
                      </span>
                    </div>

                    <span v-if="slide.composition.footage_width">
                      {{ slide.composition.footage_width }}x{{ slide.composition.footage_height }},
                      {{ slide.composition.footage_seconds.toFixed(2) }} s
                    </span>
                  </div>
                </div>
              </v-carousel-item>
            </v-carousel>
          </v-card-text>
        </base-card>
      </v-col>

      <v-col
        v-if="isSuper"
        cols="12"
        md="8"
      >
        <div ref="editor1" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { basicSetup, EditorView } from 'codemirror'
import { json } from '@codemirror/lang-json'
import { Compartment } from '@codemirror/state'
import moment from 'moment-timezone'

const languageConf = new Compartment()

export default {
  name: 'JobDetails',

  metaInfo: {
    title: 'Job Details',
  },

  data () {
    return {
      tab: '',

      template: {
        name: '',
      },

      job: {
        job_status: {},
      },

      fileParsing: false,

      uploadedAepFile: {
        size: 0,
        name: '',
        lastModifiedDate: null,
        url: '',

        project: {
          compositions: [],
        },

        root: {
          name: '',
          compDur: 0,
        },

        props: [],
      },

      polling: null,

      view: null,
      content: '',

      sliderText: 0,
      sliderImage: 0,

      initLoad: false,

      imageAssets: [],
      textAssets: [],
    }
  },

  computed: {
    loading () {
      return this.$store.getters.isDataLoaded
    },

    isSuper () {
      return this.$store.getters.isSuperadmin
    },
  },

  watch: {},

  mounted () {
    this.content =
      JSON.stringify(
        '{}',
        null,
        ' ',
      )

    this.view =
      new EditorView({
        doc: this.content,

        extensions: [
          basicSetup,
          json(),
        ],

        parent:
        this.$refs.editor1,
      })
  },

  created () {
    this.getJob(
      this.$route.params.job_id,
    )

    this.pollData()
  },

  beforeDestroy () {
    clearInterval(
      this.polling,
    )
  },

  methods: {
    pollData () {
      this.polling =
        setInterval(
          () => {
            if (
              this.job.state === 'error' ||
              this.job.state === 'done'
            ) {
              return
            }

            this.getJob(
              this.$route.params.job_id,
              true,
            )
          },
          5000,
        )
    },

    editorChanged (content) {
      this.content =
        JSON.stringify(
          content,
          null,
          ' ',
        )

      const transaction =
        this.view.state.update({
          changes: {
            from: 0,
            to:
            this.view.state.doc.length,
            insert:
            this.content,
          },
        })

      this.view.dispatch(
        transaction,
      )
    },

    getJob (id, silent) {
      if (!silent) {
        this.$store.commit(
          'setPageLoader',
        )
      }

      const args = {
        'id[eq]': id,
        $expand: '*',
      }

      const req =
        this.$store.dispatch(
          'nexrenderJobs',
          args,
        )

      return Promise.all([
        req,
      ])
        .then((res) => {
          const items =
            res[0] || []

          if (!items.length) {
            this.$router.push({
              name: 'NexrenderPage',
            })

            return
          }

          const item =
            items[0]

          item.jobTimeCalc = ''

          let end =
            Date.now()

          if (
            item.job_status.errorAt
          ) {
            end =
              moment(
                item.job_status.errorAt,
              )
          }

          if (
            item.job_status.finishedAt
          ) {
            end =
              moment(
                item.job_status.finishedAt,
              )
          }

          const played =
            end -
            moment(
              item.job_status.createdAt,
            ).utc()

          item.jobTimeCalc =
            moment
              .utc(played)
              .format('HH:mm:ss')

          item.result_url =
            this.processResultURL(
              item.output_url,
            )

          this.editorChanged(
            item.result_job,
          )

          this.job = item

          const args = {
            'id[eq]':
            item.project_id,
          }

          const templateReq =
            this.$store.dispatch(
              'aepProjects',
              args,
            )

          if (!this.initLoad) {
            return Promise.all([
              templateReq,
            ])
              .then((res) => {
                const items =
                  res[0] || []

                if (items.length) {
                  this.template =
                    items[0]
                }

                this.initLoad =
                  true

                this.processAssets()
              })
              .catch((errorMsg) => {
                this.$store.commit(
                  'showSnackbar',
                  {
                    text:
                    errorMsg,

                    timeout:
                      6000,

                    color:
                      'error',
                  },
                )
              })
          }
        })
        .catch((errorMsg) => {
          this.$store.commit(
            'showSnackbar',
            {
              text:
              errorMsg,

              timeout:
                6000,

              color:
                'error',
            },
          )

          this.$router.push({
            name: 'NexrenderPage',
          })
        })
        .finally(() => {
          this.$store.commit(
            'resolvePageLoader',
          )
        })
    },

    processAssets () {
      if (
        !this.job.result_job ||
        !this.job.result_job.assets
      ) {
        return
      }

      const compMap = {}

      if (
        this.template &&
        this.template.assets
      ) {
        for (
          let i = 0;
          i < this.template.assets.length;
          i += 1
        ) {
          const asset =
            this.template.assets[i]

          compMap[
            asset.composition.name
            ] =
            asset.composition
        }
      }

      for (
        let i = 0;
        i < this.job.result_job.assets.length;
        i += 1
      ) {
        const asset =
          this.job.result_job.assets[i]

        if (
          asset.type === 'image'
        ) {
          const newImage = {
            image:
            asset.src,

            layer:
            asset.layerName,

            composition: {
              name:
              asset.composition,
            },
          }

          // eslint-disable-next-line no-prototype-builtins
          if (
            compMap.hasOwnProperty(
              asset.composition,
            )
          ) {
            newImage.composition =
              compMap[
                asset.composition
                ]
          }

          this.imageAssets.push(
            newImage,
          )
        }

        if (
          asset.type === 'data'
        ) {
          const newText = {
            text:
            asset.value,

            layer:
            asset.layerName,

            composition: {
              name:
              asset.composition,
            },
          }

          // eslint-disable-next-line no-prototype-builtins
          if (
            compMap.hasOwnProperty(
              asset.composition,
            )
          ) {
            newText.composition =
              compMap[
                asset.composition
                ]
          }

          this.textAssets.push(
            newText,
          )
        }
      }
    },

    maskFTPPassword (link) {
      if (!link) {
        return ''
      }

      return link.replace(
        /^(ftp:\/\/[^:/]+:)([^@]+)(@)/i,
        '$1***$3',
      )
    },

    processResultURL (link) {
      if (!link) {
        return ''
      }

      link = link.replace(
        /^ftp:\/\/mastervod:[^@]+@storage007\.noisypeak\.com/i,
        'https://storage007.noisypeak.com/mastervod',
      )

      link = link.replace(
        /^ftp:\/\/template007:[^@]+@storage007\.noisypeak\.com/i,
        'https://storage007.noisypeak.com/result',
      )

      link = link.replace(
        /^ftp:\/\/playout4:[^@]+@storage005\.noisypeak\.com\//i,
        'https://storage005.noisypeak.com/playout4/',
      )

      return link
    },
  },
}
</script>

<style lang="scss">
.cm-editor * {
  font-size: 13px !important;
}
</style>
